import { EditIntegration } from './EditIntegration';

export default EditIntegration;